/* eslint-disable */
export const arrowdownIcon = {
  data: `<svg viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.56055 1.46411L4.46475 4.36831L7.36895 1.46411" stroke="currentColor" stroke-width="1.54891" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'arrowdown' as const,
};
